import { pickLocalizedText } from './hydrateTestFromApi'

type UnknownRecord = Record<string, unknown>

function asRecord(o: unknown): UnknownRecord | null {
  if (o !== null && typeof o === 'object' && !Array.isArray(o)) {
    return o as UnknownRecord
  }
  return null
}

function coerceBool(v: unknown): boolean {
  if (v === true || v === 1 || v === '1') {
    return true
  }
  return false
}

function isCorrectOption(opt: UnknownRecord): boolean {
  return coerceBool(opt.isCorrectAnswer ?? opt.IsCorrectAnswer)
}

function resolveAttemptAnswerRowForOption(
  attemptAnswers: UnknownRecord[] | null,
  opt: UnknownRecord,
  optionIndex: number
): UnknownRecord | null {
  if (!attemptAnswers || attemptAnswers.length === 0) {
    return null
  }
  const optId = String(opt.id ?? opt.Id ?? '').trim()
  if (optId !== '') {
    const hit = attemptAnswers.find((a) => {
      if (!a || typeof a !== 'object') {
        return false
      }
      const row = a as UnknownRecord
      const aid = String(
        row.answerId ??
          row.AnswerId ??
          row.answerOptionId ??
          row.AnswerOptionId ??
          row.optionId ??
          row.OptionId ??
          row.id ??
          row.Id ??
          ''
      ).trim()
      return aid !== '' && aid === optId
    })
    if (hit && typeof hit === 'object') {
      return hit as UnknownRecord
    }
  }
  const byIndex = attemptAnswers[optionIndex]
  if (byIndex && typeof byIndex === 'object') {
    return byIndex as UnknownRecord
  }
  return null
}

function pickExplanationTextFromSources(
  attemptRow: UnknownRecord | null,
  opt: UnknownRecord,
  lang: string
): string {
  if (attemptRow) {
    const fromAttempt = pickLocalizedText(
      attemptRow.explanatoryText ?? attemptRow.ExplanatoryText,
      lang
    ).trim()
    if (fromAttempt) {
      return fromAttempt
    }
  }
  const fromDef = pickLocalizedText(
    opt.explanatoryText ?? opt.ExplanatoryText,
    lang
  ).trim()
  return fromDef
}

/**
 * Пояснение к правильному ответу: attempt answer → fallback answerOptions[].explanatoryText.
 */
export function pickCorrectOptionExplanation(
  optionsRaw: unknown,
  attemptAnswersRaw: unknown,
  lang: string
): string {
  const opts = Array.isArray(optionsRaw) ? optionsRaw : []
  const attemptAnswers = Array.isArray(attemptAnswersRaw)
    ? (attemptAnswersRaw as UnknownRecord[])
    : null

  for (let oi = 0; oi < opts.length; oi += 1) {
    const opt = asRecord(opts[oi])
    if (!opt || !isCorrectOption(opt)) {
      continue
    }
    const attemptRow = resolveAttemptAnswerRowForOption(attemptAnswers, opt, oi)
    const text = pickExplanationTextFromSources(attemptRow, opt, lang)
    if (text) {
      return text
    }
  }

  for (let oi = 0; oi < opts.length; oi += 1) {
    const opt = asRecord(opts[oi])
    if (!opt) {
      continue
    }
    const attemptRow = resolveAttemptAnswerRowForOption(attemptAnswers, opt, oi)
    const text = pickExplanationTextFromSources(attemptRow, opt, lang)
    if (text) {
      return text
    }
  }

  return ''
}

export function pickShowCorrectAnswersFromTestData(
  testData: UnknownRecord
): boolean {
  const raw =
    testData.showCorrectAnswers ??
    testData.ShowCorrectAnswers ??
    testData.settings?.showCorrectAnswers ??
    testData.Settings?.ShowCorrectAnswers
  if (typeof raw === 'boolean') {
    return raw
  }
  if (raw === 1 || raw === '1') {
    return true
  }
  return false
}

export function pickShowExplanationsTypeFromTestData(
  testData: UnknownRecord
): number {
  const raw =
    testData.showExplanationsType ??
    testData.ShowExplanationsType ??
    testData.settings?.showExplanationsType ??
    testData.Settings?.ShowExplanationsType
  if (raw == null || raw === '') {
    return 1
  }
  const n = typeof raw === 'number' ? raw : Number(raw)
  if (!Number.isFinite(n)) {
    return 1
  }
  return Math.max(0, Math.min(3, Math.floor(n)))
}

export type ShouldShowExplanationsContext = {
  showCorrectAnswers: boolean
  explainType: number
  /** Текущий вопрос зафиксирован («Далее») */
  answerLocked?: boolean
  /** Все вопросы отвечены / тест завершён */
  allAnswered?: boolean
  /** Набран проходной балл */
  passed?: boolean
  /** Экран итогов (модалка / report) — тест уже сдан */
  isResultsView?: boolean
}

export function shouldShowExplanations(
  ctx: ShouldShowExplanationsContext
): boolean {
  if (!ctx.showCorrectAnswers) {
    return false
  }
  if (ctx.explainType === 0) {
    return false
  }
  const results = Boolean(ctx.isResultsView)
  const locked = Boolean(ctx.answerLocked)
  const allDone = Boolean(ctx.allAnswered) || results
  const passed = Boolean(ctx.passed)

  if (ctx.explainType === 3) {
    return locked || results
  }
  if (ctx.explainType === 1) {
    return allDone
  }
  if (ctx.explainType === 2) {
    return allDone && passed
  }
  return false
}
import { pickLocalizedText } from './hydrateTestFromApi'

type UnknownRecord = Record<string, unknown>

function asRecord(o: unknown): UnknownRecord | null {
  if (o !== null && typeof o === 'object' && !Array.isArray(o)) {
    return o as UnknownRecord
  }
  return null
}

function coerceBool(v: unknown): boolean {
  if (v === true || v === 1 || v === '1') {
    return true
  }
  return false
}

function isCorrectOption(opt: UnknownRecord): boolean {
  return coerceBool(opt.isCorrectAnswer ?? opt.IsCorrectAnswer)
}

function resolveAttemptAnswerRowForOption(
  attemptAnswers: UnknownRecord[] | null,
  opt: UnknownRecord,
  optionIndex: number
): UnknownRecord | null {
  if (!attemptAnswers || attemptAnswers.length === 0) {
    return null
  }
  const optId = String(opt.id ?? opt.Id ?? '').trim()
  if (optId !== '') {
    const hit = attemptAnswers.find((a) => {
      if (!a || typeof a !== 'object') {
        return false
      }
      const row = a as UnknownRecord
      const aid = String(
        row.answerId ??
          row.AnswerId ??
          row.answerOptionId ??
          row.AnswerOptionId ??
          row.optionId ??
          row.OptionId ??
          row.id ??
          row.Id ??
          ''
      ).trim()
      return aid !== '' && aid === optId
    })
    if (hit && typeof hit === 'object') {
      return hit as UnknownRecord
    }
  }
  const byIndex = attemptAnswers[optionIndex]
  if (byIndex && typeof byIndex === 'object') {
    return byIndex as UnknownRecord
  }
  return null
}

function pickExplanationTextFromSources(
  attemptRow: UnknownRecord | null,
  opt: UnknownRecord,
  lang: string
): string {
  if (attemptRow) {
    const fromAttempt = pickLocalizedText(
      attemptRow.explanatoryText ?? attemptRow.ExplanatoryText,
      lang
    ).trim()
    if (fromAttempt) {
      return fromAttempt
    }
  }
  const fromDef = pickLocalizedText(
    opt.explanatoryText ?? opt.ExplanatoryText,
    lang
  ).trim()
  return fromDef
}

/**
 * Пояснение к правильному ответу: attempt answer → fallback answerOptions[].explanatoryText.
 */
export function pickCorrectOptionExplanation(
  optionsRaw: unknown,
  attemptAnswersRaw: unknown,
  lang: string
): string {
  const opts = Array.isArray(optionsRaw) ? optionsRaw : []
  const attemptAnswers = Array.isArray(attemptAnswersRaw)
    ? (attemptAnswersRaw as UnknownRecord[])
    : null

  for (let oi = 0; oi < opts.length; oi += 1) {
    const opt = asRecord(opts[oi])
    if (!opt || !isCorrectOption(opt)) {
      continue
    }
    const attemptRow = resolveAttemptAnswerRowForOption(attemptAnswers, opt, oi)
    const text = pickExplanationTextFromSources(attemptRow, opt, lang)
    if (text) {
      return text
    }
  }

  for (let oi = 0; oi < opts.length; oi += 1) {
    const opt = asRecord(opts[oi])
    if (!opt) {
      continue
    }
    const attemptRow = resolveAttemptAnswerRowForOption(attemptAnswers, opt, oi)
    const text = pickExplanationTextFromSources(attemptRow, opt, lang)
    if (text) {
      return text
    }
  }

  return ''
}

export function pickShowCorrectAnswersFromTestData(
  testData: UnknownRecord
): boolean {
  const raw =
    testData.showCorrectAnswers ??
    testData.ShowCorrectAnswers ??
    testData.settings?.showCorrectAnswers ??
    testData.Settings?.ShowCorrectAnswers
  if (typeof raw === 'boolean') {
    return raw
  }
  if (raw === 1 || raw === '1') {
    return true
  }
  return false
}

export function pickShowExplanationsTypeFromTestData(
  testData: UnknownRecord
): number {
  const raw =
    testData.showExplanationsType ??
    testData.ShowExplanationsType ??
    testData.settings?.showExplanationsType ??
    testData.Settings?.ShowExplanationsType
  if (raw == null || raw === '') {
    return 1
  }
  const n = typeof raw === 'number' ? raw : Number(raw)
  if (!Number.isFinite(n)) {
    return 1
  }
  return Math.max(0, Math.min(3, Math.floor(n)))
}

export type ShouldShowExplanationsContext = {
  showCorrectAnswers: boolean
  explainType: number
  /** Текущий вопрос зафиксирован («Далее») */
  answerLocked?: boolean
  /** Все вопросы отвечены / тест завершён */
  allAnswered?: boolean
  /** Набран проходной балл */
  passed?: boolean
  /** Экран итогов (модалка / report) — тест уже сдан */
  isResultsView?: boolean
}

export function shouldShowExplanations(
  ctx: ShouldShowExplanationsContext
): boolean {
  if (!ctx.showCorrectAnswers) {
    return false
  }
  if (ctx.explainType === 0) {
    return false
  }
  const results = Boolean(ctx.isResultsView)
  const locked = Boolean(ctx.answerLocked)
  const allDone = Boolean(ctx.allAnswered) || results
  const passed = Boolean(ctx.passed)

  if (ctx.explainType === 3) {
    return locked || results
  }
  if (ctx.explainType === 1) {
    return allDone
  }
  if (ctx.explainType === 2) {
    return allDone && passed
  }
  return false
}
